import { type PropsWithChildren } from "react";

import { TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";

import { useShowTableSelectColumn } from "../../../hooks/use-show-table-select-column";
import { FIXED_NAME_COLUMN_ID, SELECTION_COLUMN_WIDTH } from "../constants";

export const TableHeaderCell = (
  props: PropsWithChildren<TableHeaderRow.CellProps>,
) => {
  const [showSelectColumn] = useShowTableSelectColumn();
  const leftOffset = showSelectColumn ? SELECTION_COLUMN_WIDTH : 0;

  return (
    <TableHeaderRow.Cell
      {...props}
      style={
        props.column.name === FIXED_NAME_COLUMN_ID
          ? { left: `${leftOffset}px` }
          : {}
      }
    />
  );
};
